import { ATLAS_PROJECT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggAtlasProjectToLegacyField: FieldTransformer<
	typeof ATLAS_PROJECT_CF_TYPE
> = (node) => {
	if (node.type !== ATLAS_PROJECT_CF_TYPE) return undefined;

	const selectedProject = node.project;
	const value = selectedProject ? { project: selectedProject } : null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			configuration: null,
			custom: ATLAS_PROJECT_CF_TYPE,
			items: null,
			renderer: null,
			system: null,
			type: ATLAS_PROJECT_CF_TYPE,
		},
	};
};
